module.exports = __webpack_public_path__ + "img/qrcode.2c1f05ba.png";